export default __webpack_public_path__ + "static/media/placeholder-large.6463c590.png";